<div class="main-buttons d-print-none">
  <div class="row">
    <div class="col buttons">
      <!-- Cancel -->
      <button
        type="button"
        mat-stroked-button
        *ngIf="
          (rsf?.status == formStatusEnum.New ||
            rsf?.status == formStatusEnum.Draft ||
            rsf?.status == formStatusEnum.AmendmentDrafting) &&
          formDirty
        "
        color="warn"
        (click)="buttonAction.emit({ action: action.Discard })"
      >
        Discard
      </button>

      <!-- Cancel -->
      <button
        type="button"
        mat-flat-button
        *ngIf="
          (rsf?.status == formStatusEnum.New ||
            rsf?.status == formStatusEnum.Draft) &&
          privileges?.canCancel &&
          !formDirty
        "
        color="warn"
        (click)="buttonAction.emit({ action: action.Cancel })"
      >
        Cancel
      </button>

      <!-- Cancel Amendment -->
      <button
        type="button"
        mat-flat-button
        *ngIf="cancelAmendmentEnabled"
        color="warn"
        (click)="buttonAction.emit({ action: action.CancelAmendment })"
      >
        Cancel Amendment
      </button>
    </div>

    <div class="col d-flex justify-content-end buttons">
      <!-- Update Draft / Save Draft (label depends on rsf?.status) -->
      <button
        type="button"
        mat-flat-button
        *ngIf="
          (rsf?.status == formStatusEnum.New ||
            rsf?.status == formStatusEnum.Draft) &&
          (privileges?.canEdit || privileges?.canCreate) &&
          (status?.isCreating || status?.isEditing)
        "
        [disabled]="disabled || !formDirty"
        color="accent"
        (click)="buttonAction.emit({ action: action.SaveDraft })"
      >
        {{ rsf?.status !== formStatusEnum.New ? "Update Draft" : "Save Draft" }}
      </button>

      <!-- Submit -->
      <button
        type="button"
        mat-flat-button
        [disabled]="disabled || !formValid"
        *ngIf="privileges?.canSubmit && rsf?.status == formStatusEnum.Draft"
        color="primary"
        (click)="buttonAction.emit({ action: action.Submit })"
      >
        Submit
      </button>

      <!-- Unsubmit -->
      <button
        type="button"
        mat-flat-button
        *ngIf="unsubmitEnabled"
        color="warn"
        (click)="buttonAction.emit({ action: action.Unsubmit })"
      >
        Unsubmit
      </button>

      <!-- Update Amendment -->
      <button
        type="button"
        mat-flat-button
        *ngIf="
          status?.isViewingAmendment &&
          privileges?.canEditAmendment &&
          rsf?.status == formStatusEnum.AmendmentDrafting
        "
        [disabled]="disabled || !formDirty"
        color="accent"
        (click)="buttonAction.emit({ action: action.SaveAmendment })"
      >
        Update Amendment
      </button>

      <!-- Submit Amendment -->
      <button
        type="button"
        mat-flat-button
        [disabled]="
          disabled ||
          !formValid ||
          !amendmentHasChanges ||
          (!isFormDirty() && !amendmentChangesSaved)
        "
        *ngIf="
          privileges?.canSubmitAmendment &&
          status?.isViewingAmendment &&
          (status?.isEditingAmendment || status?.isCreatingAmendment)
        "
        color="primary"
        (click)="buttonAction.emit({ action: action.SubmitAmendment })"
      >
        Submit Amendment
      </button>

      <!-- Unsubmit Amendment -->
      <button
        type="button"
        mat-flat-button
        *ngIf="unsubmitAmendmentEnabled"
        color="warn"
        (click)="buttonAction.emit({ action: action.UnsubmitAmendment })"
      >
        Unsubmit Amendment
      </button>

      <!-- OIC Disapprove -->
      <button
        type="button"
        mat-flat-button
        *ngIf="oicDisapproveEnabled"
        color="warn"
        (click)="oicDisapprove()"
      >
        <span class="d-flex"
          >Disapprove <role-chips class="ml-1" roleCodes="OIC"></role-chips>
        </span>
      </button>
    </div>
  </div>
</div>
